import { render, staticRenderFns } from "./cosDocDetail.vue?vue&type=template&id=5a543425&scoped=true"
import script from "./cosDocDetail.vue?vue&type=script&lang=js"
export * from "./cosDocDetail.vue?vue&type=script&lang=js"
import style0 from "./cosDocDetail.vue?vue&type=style&index=0&id=5a543425&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a543425",
  null
  
)

export default component.exports